import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IImage } from 'old-store/types/gallery';

interface IIsOpen {
  isOpen: boolean;
  image: IImage | null;
}

interface IModalsState {
  productsDrawer: IIsOpen;
}

const initialState: IModalsState = {
  productsDrawer: {
    isOpen: false,
    image: null
  }
};

const drawersSlice = createSlice({
  name: 'drawers',
  initialState,
  reducers: {
    openProductsDrawer(state, action: PayloadAction<{ image?: IImage }>) {
      state.productsDrawer.isOpen = true;

      if (action.payload.image) {
        state.productsDrawer.image = action.payload.image;
      }
    },
    closeProductsDrawer(state) {
      state.productsDrawer.isOpen = false;
    }
  }
});

export const { openProductsDrawer, closeProductsDrawer } = drawersSlice.actions;

export const drawersReducer = drawersSlice.reducer;
